import React, { createContext, FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Outlet, Link, useParams } from 'react-router-dom';

import { Data, Tournament } from '../database.schema';

import { createGlobalStyle } from 'styled-components';

import * as CSS from './components/navigation/navigation-styles';
import { Navigation } from './components/navigation/navigation';
import Spinner from './components/spinner/spinner';
import { FlexRowCentred } from './components/common-styles/common-styles';
import { useFetchData } from './api/tournament-data';
import { CreateTournament } from './components/tournament-admin/create-tournament';
import { TOURNAMENT_STATE_IN_PLAY } from './app/constants';
import { isLoggedIn } from './app/authentication/auth';
import { LoginForm } from './components/login/login';
import { getTourGroup } from './utils/get-tour-group';

// const Points = styled.div<{ color?: string }>`
//   color: ${(props) => props.color || 'black'};
const GlobalStyles = createGlobalStyle`
  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    font-family: 'Roboto', sans-serif;
  }
  html {
    height: fit-content;
  }
  body {
    font-family: 'Roboto', sans-serif;
    height: 100%;
    position: relative;
    max-width: 30rem;
    margin: auto;
  }
`;

export const PageContainer = styled.div`
  margin: 0 0.5rem;
  h1 {
    margin: 0;
  }
`;

export const Header = styled.div<{ color?: string }>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.25rem;
  margin-left: 4rem;
  padding: 0.5rem 0;
  color: ${(props) => props.color || 'black'};
`;

export const PreviousTourHeader = styled.div<{ color?: string }>`
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 0.25rem;
  padding: 0.5rem 0;
  color: ${(props) => props.color || 'black'};
`;

export const RouterLink = styled(Link)`
  font-size: 15px;
  color: black;
  text-decoration: none;
`;

const Notes = styled.div`
  margin-bottom: 0.5rem;
`;
const Note = styled.p`
  font-size: 11px;
  color: red;
  margin: 0;
  margin-bottom: 0.25rem;
`;

export const SelectedIndexContext = createContext({ selectedTournamentIndex: 0, setSelectedTournamentIndex: (index: number) => {} });

const App: FC = () => {
  const params = useParams();
  const { data, error, isLoading } = useFetchData((data: Data) => data);
  const [selectedTournamentIndex, setSelectedTournamentIndex] = useState(0);
  const [tournamentIndex, setTournamentIndex] = useState(params.previousTournamentIndex ? Number(params.previousTournamentIndex) : -1);
  const [tournaments, setTournaments] = useState<Array<Tournament>>([]);
  const [isPreviousTour, setIsPreviousTour] = useState<boolean>(false);

  useEffect(() => {
    if (data) {
      const dataX = data as Data;
      const tournamentIndex = dataX?.tournaments ? dataX.tournaments.length - 1 : -1;
      setSelectedTournamentIndex(tournamentIndex);
      setTournamentIndex(tournamentIndex);
      setTournaments(dataX.tournaments ? dataX.tournaments : []);
    }
  }, [data]);

  useEffect(() => {
    if (params.previousTournamentIndex) {
      setTournamentIndex(Number(params.previousTournamentIndex));
      setIsPreviousTour(true);
    } else {
      setTournamentIndex(selectedTournamentIndex);
      setIsPreviousTour(false);
    }
  }, [params]);

  if (isLoading) {
    return <Spinner size="small" withOverlay={true} />;
  }

  if (error) {
    return <div>Oops something went wrong!!</div>;
  }
  if (tournaments && tournaments[tournamentIndex] && tournaments.some((tournament) => tournament.state === TOURNAMENT_STATE_IN_PLAY)) {
    return (
      <SelectedIndexContext.Provider value={{ selectedTournamentIndex, setSelectedTournamentIndex }}>
        <div>
          <GlobalStyles />

          {!isPreviousTour && <Navigation />}
          <PageContainer data-testid="app">
            {!isPreviousTour && (
              <Header color="black">
                <RouterLink data-testid="page-header" to={'/'}>
                  <h1>{`Golf Tour:  ${tournaments[tournamentIndex]?.year}`}</h1>
                </RouterLink>
                {tournaments[tournamentIndex].itinerary && (
                  <Link to={'/itinerary'}>
                    <img style={{ height: '40px', width: '40px', marginRight: '0.25rem' }} src="/itinerary-calendar.png" />
                  </Link>
                )}
              </Header>
            )}
            {isPreviousTour && (
              <PreviousTourHeader color="green">
                <RouterLink to={'/'}>
                  <h1>{`Previous Tour:  ${tournaments[tournamentIndex]?.year}`}</h1>
                </RouterLink>
                <RouterLink to={'/'}>
                  <CSS.HamburgerContainer>
                    <FlexRowCentred>
                      <div>
                        <CSS.HamburgerBar1 data-testid="bar1" style={{ transform: 'translate(2px, 8px) rotate(-45deg)', backgroundColor: 'black' }}></CSS.HamburgerBar1>
                        <CSS.HamburgerBar2 data-testid="bar2" style={{ opacity: 0 }}></CSS.HamburgerBar2>
                        <CSS.HamburgerBar1 data-testid="bar3" style={{ transform: 'translate(2px, -11px) rotate(45deg)', backgroundColor: 'black' }}></CSS.HamburgerBar1>
                      </div>
                    </FlexRowCentred>
                  </CSS.HamburgerContainer>
                </RouterLink>
              </PreviousTourHeader>
            )}
            {tournaments[tournamentIndex]?.notes && (
              <Notes data-testid="notes">
                {tournaments[tournamentIndex]?.notes?.map((note: string, index: number) => (
                  <Note key={`note-${index}`}>{note}</Note>
                ))}
              </Notes>
            )}
            <Outlet />
          </PageContainer>
        </div>
      </SelectedIndexContext.Provider>
    );
  }
  return (
    <SelectedIndexContext.Provider value={{ selectedTournamentIndex, setSelectedTournamentIndex }}>
      <div>
        <GlobalStyles />

        <Navigation />
        <PageContainer data-testid="app">
          <Header>
            <h1>Golf Tour</h1>
          </Header>
          <CreateTournament />
          {!isLoggedIn() && <LoginForm />}
        </PageContainer>
      </div>
    </SelectedIndexContext.Provider>
  );
};

export default App;
